var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive
    ? _c(
        "base-modal-ex",
        {
          attrs: {
            active: _vm.isActive,
            "animation-in": _vm.animationIn,
            "animation-out": _vm.animationOut,
            "animation-duration": _vm.animationDuration,
            "can-cancel": false,
            "min-width": _vm.minWidth,
            "has-modal-card": "",
          },
          on: {
            "update:active": function ($event) {
              _vm.isActive = $event
            },
          },
        },
        [
          _c("div", { staticClass: "model-content" }, [
            _c("div", { staticClass: "modal-card" }, [
              _c("header", { staticClass: "modal-card-head" }, [
                _c(
                  "p",
                  {
                    staticClass: "modal-card-title",
                    class: { "is-flex-items-center": _vm.showIcon },
                  },
                  [
                    _vm.showIcon
                      ? _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", {
                            staticClass: "mdi mdi-36px mdi-view-list",
                          }),
                        ])
                      : _vm._e(),
                    _c("span", { staticClass: "ml-2" }, [
                      _vm._v("Category Totals"),
                    ]),
                  ]
                ),
              ]),
              _c("section", { staticClass: "modal-card-body" }, [
                _c(
                  "article",
                  [
                    _c("quote-detail-assessment-summary", {
                      attrs: { value: _vm.value },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "footer",
                {
                  staticClass: "modal-card-foot",
                  style: `justify-content: flex-${_vm.buttonLocation}`,
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button tooltip is-tooltip-topright",
                      attrs: { "data-tooltip": "Close" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }